<template>
  <div class="home_page">
    <!-- <el-breadcrumb separator="/" style="line-height: 40px">
      <el-breadcrumb-item :to="{ name: 'basicInfo' }">个人中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'orderList' }">我的订单</el-breadcrumb-item>
      <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
    </el-breadcrumb> -->
    <div class="shipment_detail">
      <div class="detail_row flex-between">
        <div class="top_title">发货情况</div>
        <div class="">状态：
          <font style="color: red;">{{$route.query.orderStatus}}</font>
        </div>
      </div>
      <!-- 订单信息 -->
      <div class="detail_row flex-between">
        <div class="detail_row">
          <label class="flex-shrink">订单号：</label>
          <div>{{$route.query.orderCode}}</div>
        </div>
        <div class="detail_row">
          <label class="flex-shrink">用户名：</label>
          <div>{{$route.query.userName}}</div>
        </div>
        <div class="detail_row">
          <label class="flex-shrink">采购公司：</label>
          <div>{{$route.query.companyName}}</div>
        </div>
      </div>
      <!-- 发货单 -->
      <el-table :data="shipmentList"
                border
                :row-key="getRowKey"
                :expand-row-keys="expandKeys"
                @expand-change="getGoodsById"
                v-loading="butLoading">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div style="margin-top:20px">
              <el-collapse v-model="activeName"
                           accordion>
                <el-collapse-item title="物流信息"
                                  name="1">
                  <el-table :data="logisticsList"
                            :show-header="false"
                            :border="false"
                            class="logisticsList-table"
                            empty-text="-----------暂无物流信息-------------"
                            style="width: 100%">
                    <el-table-column prop="time"
                                     label="时间"
                                     width="200">
                    </el-table-column>
                    <el-table-column prop="status"
                                     label="位置"
                                     width="180">
                    </el-table-column>
                    <el-table-column prop="context"
                                     label="状态">
                    </el-table-column>
                  </el-table>
                </el-collapse-item>
              </el-collapse>
            </div>
            <el-table :data="deliverGoods"
                      :key="scope.deliveryId">
              <el-table-column prop="goodsName"
                               label="商品名称"></el-table-column>
              <el-table-column prop="goodsModel"
                               label="商品型号"></el-table-column>
              <el-table-column prop="goodsNum"
                               label="发货量"></el-table-column>
              <el-table-column prop="trackNums"
                               label="运单号"></el-table-column>
              <el-table-column label="折扣率"
                               v-if="deliverDetail && deliverDetail.joinMarketing">
                <template slot-scope="scope">
                  <span :label="scope.row.discount">{{scope.row.discount}}%</span>
                </template>
              </el-table-column>
              <el-table-column label="单价"
                               v-if="deliverDetail && deliverDetail.joinMarketing">
                <template slot-scope="scope">
                  <span :label="scope.row.goodsPrice"
                        class="discount">{{scope.row.goodsPrice}}</span><br />
                  <span :label="scope.row.goodsPriceDiscount">{{scope.row.goodsPriceDiscount}}</span>
                </template>
              </el-table-column>
              <el-table-column label="单价"
                               v-else>
                <template slot-scope="scope">
                  <span :label="scope.row.goodsPrice">{{scope.row.goodsPrice}}</span>
                </template>
              </el-table-column>
              <el-table-column label="总价"
                               v-if="deliverDetail && deliverDetail.joinMarketing">
                <template slot-scope="scope">
                  <span :label="scope.row.money"
                        class="discount">{{scope.row.money}}</span><br />
                  <span :label="scope.row.goodsMoney">{{scope.row.goodsMoney}}</span>
                </template>
              </el-table-column>
              <el-table-column label="总价"
                               v-else>
                <template slot-scope="scope">
                  <span :label="scope.row.money">{{scope.row.money}}</span>
                </template>
              </el-table-column>

              <!-- <el-table-column label="单价">
                <template slot-scope="scope">
                  <span :label="scope.row.goodsPrice">{{scope.row.goodsPrice}}</span>
                </template>
              </el-table-column>
              <el-table-column label="合计">
                <template slot-scope="scope">
                  <span :label="scope.row.goodsMoney">{{scope.row.goodsMoney}}</span>
                </template>
              </el-table-column> -->
            </el-table>
            <!-- 确认收货，总金额 -->
            <el-row class="money"
                    v-if="deliverDetail && deliverDetail.joinMarketing">
              <el-col :span="3"
                      :offset="11"
                      class="color">
                <span style="color:#588bbb"
                      v-show="deliverDetail && deliverDetail.deliveryStatus === '30'">{{'已确认收货'}}</span>&nbsp;
              </el-col>
              <el-col :span="4">
                <el-form-item label="折扣金额：">
                  <span style="color:#333">
                    <span>￥</span>
                    {{deliverDetail ? deliverDetail.discountMoney || 0 : 0}}
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                本批次商品总价：
                <!-- <el-form-item label="本批次商品总价："> -->
                <span style="color:red">
                  <span>￥</span>
                  {{deliverDetail ? deliverDetail.deliveryMoney || 0 : 0}}
                </span>
                <!-- </el-form-item> -->
              </el-col>
            </el-row>
            <el-row class="money"
                    v-else>
              <el-col :span="3"
                      :offset="16"
                      class="color">
                <div v-if="deliverDetail && deliverDetail.deliveryStatus === '30'">已确认收货</div>
                &nbsp;
              </el-col>
              <el-col :span="5">
                本批次商品总价：
                <!-- <el-form-item label="本批次商品总价："> -->
                <span style="color:red">
                  <span>￥</span>
                  {{deliverDetail ? deliverDetail.deliveryMoney || 0 : 0}}
                </span>
                <!-- </el-form-item> -->
              </el-col>
            </el-row>
            <el-row v-if="deliverDetail && deliverDetail.deliveryStatus == '20'"
                    style="margin:5px">
              <!-- <el-col :span="3" :offset="17">
                <div style="margin-top:10px">
                  <span>{{'14天后自动确认收货'}}</span>
                </div>
              </el-col> -->
              <el-col :span="4"
                      :offset="20"
                      style="text-align: center">
                <el-button class="top_btn2"
                           @click="confirmReceiptHandle(scope.row)"
                           :loading="butLoading">确认收货</el-button>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column prop="deliveryBatch"
                         label="批次"
                         width="60"></el-table-column>
        <el-table-column prop="deliveryCode"
                         label="发货单号"></el-table-column>
        <el-table-column prop="deliveryUser"
                         label="发货人"></el-table-column>
        <el-table-column prop="deliveryDate"
                         label="发货日期"></el-table-column>
        <el-table-column prop="deliveryUserMobile"
                         label="电话号码"></el-table-column>
        <el-table-column prop="logisticsCompanyName"
                         label="物流公司"></el-table-column>
        <el-table-column prop="logisticsNumber"
                         label="物流单号"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      shipmentList: [], // 发货列表
      expandKeys: [], // 展开的key
      deliverDetail: null,
      deliverGoods: [],
      logisticsList: [], // 物流信息
      activeName: '1',
      butLoading: false
    }
  },
  computed: {
    orderId () {
      return this.$route.query.orderId
    }
  },
  mounted () {
    this.getOrderShipmentList()
  },
  methods: {
    getRowKey (row) {
      return row.deliveryId
    },
    // 获取订单的发货列表
    getOrderShipmentList () {
      if (!this.orderId) {
        return false
      }
      this.$request.get(`/help/order/delivery/getByOrderId/${this.orderId}`)
        .then(res => {
          this.shipmentList = res || []
          if (this.shipmentList.length) {
            this.expandKeys = [this.shipmentList[0].deliveryId]
            this.getGoodsById(this.shipmentList[0], [this.shipmentList[0]])
          } else {
            this.expandKeys = []
          }
          // console.log(res)
        })
    },
    // 获取某条发货的商品及物流详情
    getGoodsById (row, expanded) {
      this.deliverDetail = null
      this.deliverGoods = []
      this.logisticsList = []
      if (expanded.length === 0) {
        this.expandKeys = []
        return false
      } else {
        this.expandKeys = [row.deliveryId]
        this.$request.get(`/help/order/delivery/info/${row.deliveryId}`)
          .then(data => {
            this.deliverDetail = data
            this.deliverGoods = data.deliveryItem
            // _this.discountFlag = data.result.joinMarketing
            // _this.tableData = data.result.deliveryItem
          })
          .catch(() => {
            // _this.$message.error("暂无数据")
          })
        //
        if (row.logisticsNumber && row.logisticsCompanyCode) {
          this.getLogisticsList(row.logisticsNumber, row.logisticsCompanyCode, row.receiverPhone)
        }
      }
    },
    // 获取物流信息列表
    getLogisticsList (logisticsNumber, logisticsCompanyCode, phone) {
      this.$http
        .get(`/help/consumer/logisticsCompany/getLogisticsInfo`, {
          params: {
            logisticsNumber: logisticsNumber, // -- 单号
            logisticsCompanyCode: logisticsCompanyCode, // -- 公司名
            phone: phone // 收件人手机号
          }
        })
        .then((data) => {
          if (data.data.code === 0) {
            this.logisticsList = data.data.data || []
          }
        })
    },
    // 确认收获
    confirmReceiptHandle (row) {
      if (this.butLoading) {
        return false
      }
      this.butLoading = true
      this.$http.post(`/front/consumer/order/delivery/receiptDelivery`, {
        deliveryId: row.deliveryId
      })
        .then(({ data: res }) => {
          this.butLoading = false
          if (res.code === 0) {
            this.getOrderShipmentList()
          }
        })
        .catch(() => {
          this.butLoading = false
        })
    }
  }
}
</script>
<style lang='scss' scoped>
.shipment_detail {
  background: #fff;
  padding: 30px;
  /deep/ .el-table .el-table__expanded-cell[class*="cell"] {
    padding: 0;
  }
  .detail_row {
    display: flex;
    margin-top: 20px;
    color: #666666;
    align-items: center;
    .item_col {
      margin-right: 30px;
    }
    .top_title {
      font-size: 20px;
      // margin-top: 40px;
      font-weight: 600;
      color: #333333;
    }
  }
  .flex-between {
    justify-content: space-between;
  }
  .money {
    background-color: #ebebeb;
    height: 50px;
    line-height: 50px;
    .color {
      color: #588bbb;
    }
  }
}
</style>
